import { render, staticRenderFns } from "./mIndex.vue?vue&type=template&id=54d33596"
import script from "./mIndex.vue?vue&type=script&lang=ts"
export * from "./mIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports